import { computed } from "vue";
/**
 * @param {Object} options - Dropdown options as a key-value object (e.g., { 10: "10", 20: "20", 50: "50" }).
 * @param {Ref<Object>} selectedFilters - Reactive object containing active filters (e.g., from a store).
 * @param {string} filterKey - The key in `selectedFilters` to bind this dropdown to.
 * @param {Function} [onChange] - Callback triggered when the selected value changes. Optional.
 *
 * @returns {Object} - Contains:
 *   - `options`: The dropdown options.
 *   - `selectedValue`: A computed value for the selected key's label.
 */
export function useDropdown({
  options,
  selectedFilters,
  filterKey,
  onChange = () => {},
}) {
  const selectedValue = computed({
    get() {
      return options[selectedFilters.value[filterKey]] || "Sélectionner";
    },
    set(selectedLabel) {
      const selectedKey = Object.keys(options).find(
        (key) => options[key] === selectedLabel
      );
      if (selectedKey && selectedFilters.value[filterKey] !== selectedKey) {
        const parsedKey = isNaN(selectedKey)
          ? selectedKey
          : Number(selectedKey);
        selectedFilters.value[filterKey] = parsedKey;
        onChange(parsedKey);
      }
    },
  });

  return {
    options,
    selectedValue,
  };
}
